import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TooltipLoader } from '../../global/TooltipLoader';
import styles from './PdpSharedDealerDistinctions.scss';

export class PdpSharedDealerDistinction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false,
            load: false,
        };
    }

    render() {
        const { title, description, icon: Icon, dataTn } = this.props;
        const { isHovered, load } = this.state;
        const mouseProps = description && {
            onMouseEnter: () => this.setState({ isHovered: !isHovered, load: true }),
            onMouseLeave: () => this.setState({ isHovered: !isHovered }),
        };

        return (
            <div {...mouseProps} className={styles.distinction} data-tn={dataTn}>
                <Icon className={styles.icon} />
                <span className={styles.title}>{title}</span>

                {description && (
                    <TooltipLoader
                        load={load}
                        isVisible={isHovered}
                        direction="bottom"
                        align="right"
                    >
                        {description}
                    </TooltipLoader>
                )}
            </div>
        );
    }
}

PdpSharedDealerDistinction.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    icon: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
};
